/* cSpell:words subsession */

/**
 * Timing constants for subsession workflows.
 * These values are tuned for Zoom Video SDK stability.
 */
export const SUBSESSION_DELAYS = {
    /** Time to wait after creating subsessions before opening (SDK preparation) */
    OPEN_WAIT_MS: 1000,

    /** Time for teacher audio/video to stabilize after room switch */
    TEACHER_TRANSITION_MS: 6000,

    /** Debounce time before processing late joiners (connection stability) */
    LATE_JOINER_DEBOUNCE_MS: 8000,

    /** Delay before retrying failed operations */
    RETRY_DELAY_MS: 2000,

    /** Delay between sequential user swaps (prevent SDK congestion) */
    SWAP_DELAY_MS: 300,

    /** Delay before allowing another teacher room transition */
    TRANSITION_COOLDOWN_MS: 2000,

    /** Delay for cleanup safeguard check */
    CLEANUP_VERIFY_MS: 5000,

    /** Wait time for Zoom to stabilize on page load */
    ZOOM_STABILIZE_MS: 1500
} as const

/**
 * Maximum number of breakout rooms supported by WSE.
 */
export const MAX_ROOMS = 4

/**
 * Session storage key for persisting active subsession room.
 */
export const STORAGE_KEY_BREAKOUT_ROOM = 'goc:zoomActiveSubsessionRoomId'
